import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Reservation from './Reservation';
import CancelReservation from './CancelReservation';
import ResponsivePage from './ResponsivePage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/varaa" element={<Reservation />} />
        <Route path="/peruutavaraus" element={<CancelReservation />} />
        <Route path="/test" element={<ResponsivePage />} />
      </Routes>
    </Router>
  );
}

export default App;